import axios from 'axios';
import React, { useEffect } from 'react';
import { alertRef } from '../../../App';
import { Button } from '../../../Components/StyledComponents';
import { convertCost } from '../../../Utils/functions';
import SetSMS from '../Components/SetSMS/SetSMS';
import './AllSMS.scss';

const AllSMS  = () => {
    const [ title, setTitle ] = React.useState('');//문자 제목
    const [ text, setText ] = React.useState('');//문자 내용
    const [ coupon, setCoupon ] = React.useState('');//발송 쿠폰 id
    const [ couponInfo, setCouponInfo ] = React.useState({})//쿠폰 정보
    const [ bell ,setBell ] = React.useState(0)//보유 벨
    const [ prepare, setPrepare ] = React.useState(0)//수신자 수

    useEffect(() => {
        getBell()
    },[])

    //보유 벨 Get
    const getBell = () => {
        axios.get('/api/bell')
        .then((data) => {
            setBell(data.data.Total)
            getPrepare()
        })
    }

    //수신자 수 get
    const getPrepare = () => {
        axios.get('/api/sms/all/prepare')
        .then((data) => {
            setPrepare(data.data.TargetCount)
        })
    }

    //전체 문자 발송
    const sendAllSMS = () => {
        axios.post('/api/sms/all',{
            Title : title,
            Body : text,
            Coupon : coupon
        })
        .then((data) => {
            if(data.status === 204 ){
                alertRef.current.showAlert({ title : `문자 발송이 완료 되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }else if(data.status === 200){
                alertRef.current.showAlert({ title : `보유 벨이 부족합니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `네트워크 상태 혹은 보유벨을 확인해주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    return (
        <div className='all-sms'>
            <div className='header-row'>
                <p className='header-text'>문자 {'>'}</p>
                <p className='header'>전체 문자 발송</p>
            </div>

            <div className='row' style={{ marginBottom : 24 }}>
                <div className='bell-box'>
                    보유벨 : {convertCost(bell)}개
                </div>

                <div className='count-box'>
                    전체발송자 : {convertCost(prepare)}명
                </div>
            </div>
            
            <SetSMS smsTitle={title} setSMSTitle={setTitle} smsText={text} setSMSText={setText} coupon={coupon} setCoupon={setCoupon} couponInfo={couponInfo} setCouponInfo={setCouponInfo}/>

            <Button variant='outline' disabled={ title.trim() == '' || text.trim() === ''} className="send-btn" onClick={() => alertRef.current.showAlert({ title : `전체 문자를 발송할까요?`, isConfirm : true, confirmText : '확인', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();sendAllSMS()} })}>
                문자 발송하기
            </Button>
        </div>
    )
}

export default AllSMS;